import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';
import { CustomHomepageGrid } from '@backstage/plugin-home';
import { Page, Content } from '@backstage/core-components';
import { Box, Grid } from '@material-ui/core';
import { Fragment } from 'react';
import { WelcomeBanner } from './WelcomeBanner';
import { WelcomeCard } from './WelcomeCard';
import { CatalogStats } from './CatalogStats';
import { QuickStatsCards } from './QuickStatsCards';

export const myHomePageLayout = HomePageLayoutBlueprint.make({
  params: {
    loader: async () =>
      function MyHomeLayout({ widgets }) {
        return (
          <Page themeId="home">
            <Content>
              <WelcomeBanner />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <WelcomeCard />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CatalogStats />
                </Grid>
              </Grid>

              <Box mt={3}>
                <QuickStatsCards />
              </Box>

              {widgets.length > 0 && (
                <Box mt={3}>
                  <CustomHomepageGrid>
                    {widgets.map((widget, index) => (
                      <Fragment key={widget.name ?? index}>
                        {widget.component}
                      </Fragment>
                    ))}
                  </CustomHomepageGrid>
                </Box>
              )}
            </Content>
          </Page>
        );
      },
  },
});
